'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _states = require('./states');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * ValidationTracker validates models's attribute and caches last state of validation for each
 * processed attribute. ValidationTracker re-uses cached states when both conditions are passed:
 * 1. Attribute's values are not changed
 * 2. Attribute's validators are not changed (see Validator.is())
 */
var ValidationTracker = function () {
  function ValidationTracker(onPushState) {
    _classCallCheck(this, ValidationTracker);

    this.cache = {};
    this.state = {};

    this.onPushState = onPushState;
  }

  _createClass(ValidationTracker, [{
    key: 'validateAttribute',


    /**
     * Validate model's attribute. If at the moment of validation previous validation process
     * for the same attribute is not finished (PendingState), that process is skipped.
     * @param {Model} model
     * @param {string} attribute
     * @param {Validator} validator
     * @returns {Promise<State>}
     */
    value: function validateAttribute(model, attribute, validator) {
      var _this = this;

      var cached = this.getAttributeCache(attribute);
      var value = model.get(attribute);

      var isChanged = true;

      if (cached) {
        var _cached = _slicedToArray(cached, 2),
            cachedValue = _cached[0],
            cachedValidator = _cached[1];

        isChanged = !(0, _immutable.is)(value, cachedValue) || !(0, _immutable.is)(validator, cachedValidator);
      }

      if (isChanged) {
        var skip = false;

        var curState = this.getAttributeState(attribute);

        if (curState instanceof _states.PendingState) {
          curState.abort();
        }

        var job = validator.validate(value, attribute, model).then(function (warningMessage) {
          if (!skip) {
            var state = warningMessage ? new _states.WarningState({
              attribute: attribute,
              message: warningMessage
            }) : new _states.SuccessState({
              attribute: attribute
            });

            _this.setAttributeCache(attribute, value, validator);

            _this.setAttributeState(attribute, state);

            _this.pushState(state);

            return state;
          }
        }).catch(function (errorMessage) {
          if (!skip) {
            var state = new _states.ErrorState({
              attribute: attribute,
              message: errorMessage
            });

            _this.setAttributeCache(attribute, value, validator);

            _this.setAttributeState(attribute, state);

            _this.pushState(state);

            return state;
          }
        });

        Promise.race([job, new Promise(function (r) {
          return setTimeout(function () {
            return r(new _states.PendingState({
              attribute: attribute
            }, function () {
              return skip = true;
            }));
          }, 0);
        })]).then(function (state) {
          if (state instanceof _states.PendingState) {
            _this.setAttributeState(attribute, state);

            _this.pushState(state);
          }
        });

        return job;
      }

      var cachedState = this.getAttributeState(attribute);

      this.pushState(cachedState);

      return Promise.resolve(cachedState);
    }

    /**
     * Push new validation state
     * @param {State} changes
     */

  }, {
    key: 'pushState',
    value: function pushState(changes) {
      this.onPushState && this.onPushState(changes);
    }

    /**
     * Set attribute validation state
     * @param {string} attribute
     * @param {PendingState|SuccessState|WarningState|ErrorState} state
     */

  }, {
    key: 'setAttributeState',
    value: function setAttributeState(attribute, state) {
      this.state[attribute] = state;
    }

    /**
     * Get attribute validation state
     * @param {string} attribute
     * @returns {PendingState|SuccessState|WarningState|ErrorState}
     */

  }, {
    key: 'getAttributeState',
    value: function getAttributeState(attribute) {
      return this.state[attribute];
    }

    /**
     * Set attribute cache
     * @param {string} attribute
     * @param {*} value
     * @param {Validator} validator
     */

  }, {
    key: 'setAttributeCache',
    value: function setAttributeCache(attribute, value, validator) {
      this.cache[attribute] = [value, validator];
    }

    /**
     * Get attribute cache
     * @param {string} attribute
     * @return {Array} [attrValue, attrValidator]
     */

  }, {
    key: 'getAttributeCache',
    value: function getAttributeCache(attribute) {
      return this.cache[attribute];
    }
  }]);

  return ValidationTracker;
}();

exports.default = ValidationTracker;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/ValidationTracker.js
// module id = 298
// module chunks = 0